<div class="app navigation-invert">
  <ng-container *ngIf="pageEnvironment | async as pageEnvironment">
    <app-navigation [environment]="pageEnvironment"></app-navigation>
    <main>
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </main>
    <app-footer [environment]="pageEnvironment"></app-footer>
  </ng-container>
</div>
